import RoundedButton from "../buttons/RoundedButton";

const DialogFooter = ({
  cancel = "Cancelar",
  accept = "Aceptar",
  handleCancel,
  isAcceptDisabled = false,
  handleAccept,
  deleteB = false,
  showAccept = true,
}) => {
  return (
    <>
      <RoundedButton
        color="secondary"
        label={cancel}
        handleClick={handleCancel}
      />
      {showAccept && (
        <RoundedButton
          color={deleteB ? "danger" : "success"}
          label={accept}
          handleClick={handleAccept}
          disabled={isAcceptDisabled}
        />
      )}
    </>
  );
};

export default DialogFooter;
